module.exports = __webpack_public_path__ + "Fondo.4eb0cde1482b84a80e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fondo.png
// module id = 380
// module chunks = 8